module.exports = __webpack_public_path__ + "media/img/sda/kuas-student-banner-7c2875639d16436f1c9e5a24632095d2.png";